/* eslint-disable */
// /src/services/franchiseStoreCartService.js

import {
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    orderBy,
    setDoc,
    deleteDoc,
    serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";

// 루트: franchise_cart/{ownerPhoneE164}/items/{itemId}
const getItemsColRef = (ownerPhoneE164) => {
    if (!ownerPhoneE164) throw new Error("ownerPhoneE164 is required");
    const ownerDoc = doc(db, "franchise_cart", ownerPhoneE164);
    return collection(ownerDoc, "items");
};

// 옵션 조합을 식별하는 키 (상품 + 옵션 묶음 당 1개 아이템)
const buildOptionKey = (optionSelections) => {
    if (!Array.isArray(optionSelections) || !optionSelections.length) {
        return "noopt";
    }
    const parts = optionSelections
        .map((o) => `${o.groupName || ""}:${o.value || ""}`)
        .sort();
    return parts.join("|");
};

/**
 * 가맹점 장바구니에 아이템 추가 (같은 상품+옵션 조합이면 수량만 증가)
 *
 * payload:
 *  - ownerPhoneE164: string
 *  - productId: string
 *  - productTitleSnapshot: string
 *  - thumb?: string
 *  - unitPrice: number
 *  - qty: number
 *  - optionSelections?: [{ groupName, value, extraPrice }]
 */
export async function addFranchiseStoreCartItem(payload) {
    const {
        ownerPhoneE164,
        productId,
        productTitleSnapshot,
        thumb = "",
        unitPrice = 0,
        qty = 1,
        optionSelections = [],
    } = payload || {};

    if (!ownerPhoneE164) throw new Error("ownerPhoneE164 is required");
    if (!productId) throw new Error("productId is required");

    const optionKey = buildOptionKey(optionSelections);
    const itemId = `${productId}__${optionKey}`;

    const itemsCol = getItemsColRef(ownerPhoneE164);
    const itemRef = doc(itemsCol, itemId);

    // 기존 값 읽어서 qty 누적
    let prevQty = 0;
    const snap = await getDoc(itemRef);
    if (snap.exists()) {
        const data = snap.data();
        prevQty = Number(data?.qty || 0);
    }

    const nextQty = prevQty + Number(qty || 1);

    await setDoc(
        itemRef,
        {
            ownerPhoneE164,
            productId,
            productTitleSnapshot: productTitleSnapshot || "",
            thumb,
            unitPrice: Number(unitPrice || 0),
            qty: nextQty,
            optionSelections: Array.isArray(optionSelections) ? optionSelections : [],
            optionKey,
            updatedAt: serverTimestamp(),
            ...(prevQty === 0 ? { createdAt: serverTimestamp() } : {}),
        },
        { merge: true }
    );
}

/**
 * 가맹점 장바구니 리스트 조회
 */
export async function listFranchiseStoreCartItems(ownerPhoneE164) {
    if (!ownerPhoneE164) return [];
    const itemsCol = getItemsColRef(ownerPhoneE164);
    const q = query(itemsCol, orderBy("createdAt", "desc"));
    const snap = await getDocs(q);
    const out = [];
    snap.forEach((docSnap) => {
        const data = docSnap.data();
        out.push({
            id: docSnap.id,
            ...data,
        });
    });
    return out;
}

/**
 * 장바구니 수량 변경 (0 이하이면 삭제)
 */
export async function updateFranchiseStoreCartItemQty(
    ownerPhoneE164,
    itemId,
    qty
) {
    if (!ownerPhoneE164 || !itemId) return;
    const itemsCol = getItemsColRef(ownerPhoneE164);
    const itemRef = doc(itemsCol, itemId);

    const n = Number(qty || 0);
    if (n <= 0) {
        await deleteDoc(itemRef);
        return;
    }

    await setDoc(
        itemRef,
        {
            qty: n,
            updatedAt: serverTimestamp(),
        },
        { merge: true }
    );
}

/**
 * 장바구니 아이템 삭제
 */
export async function deleteFranchiseStoreCartItem(ownerPhoneE164, itemId) {
    if (!ownerPhoneE164 || !itemId) return;
    const itemsCol = getItemsColRef(ownerPhoneE164);
    const itemRef = doc(itemsCol, itemId);
    await deleteDoc(itemRef);
}
